import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { ErrorView } from '../../common/views/ErrorView/ErrorView';
import { ErrorAPIResult } from '../../../redux/api/utils/isSuccessfulResult';
import { SmartLinkInfoBox } from '../smartLinkInfoBox/SmartLinkInfoBox';

interface SmartLinksGridFooterProps {
  hasMore: boolean;
  loadingMore: boolean;
  moreError: ErrorAPIResult['error'] | undefined;
  onShowMore: () => void;
  onRetry: () => void;
  /** A search found no page. */
  noResults: boolean;
}

/** Under the SmartLinks grid: "Show more" while the tab has more cards, the loading line, an error. */
const SmartLinksGridFooterComponent: React.FC<SmartLinksGridFooterProps> = ({
  hasMore,
  loadingMore,
  moreError,
  onShowMore,
  onRetry,
  noResults,
}) => {
  const intl = useIntl();

  if (moreError !== undefined) {
    return <ErrorView error={moreError} retry={onRetry} />;
  }
  if (loadingMore) {
    return (
      <Row className="justify-content-center my-3">
        <SmartLinkInfoBox
          text={intl.formatMessage({ id: 'app.smart-links.loading', defaultMessage: `Loading... Please wait` })}
        />
      </Row>
    );
  }
  if (noResults) {
    return (
      <p className="text-muted my-3">
        {intl.formatMessage({
          id: 'app.sml.smartlinks.search.empty',
          defaultMessage: 'No SmartLink matches this search.',
        })}
      </p>
    );
  }
  if (!hasMore) {
    return null;
  }
  return (
    <Row className="my-3">
      <Col className="d-flex justify-content-center">
        <SMLButton onClick={onShowMore} outline>
          {intl.formatMessage({ id: 'app.sml.smartlinks.showMore', defaultMessage: 'Show more' })}
        </SMLButton>
      </Col>
    </Row>
  );
};

export const SmartLinksGridFooter = TypedMemo(SmartLinksGridFooterComponent);
